/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from "react";
import { MDBBtn, MDBCollapse, MDBContainer, MDBInput } from "mdb-react-ui-kit";
import { TfiAngleDown, TfiAngleUp } from "react-icons/tfi";

import { CustomToolTip, Stages } from "../../../components";
import { AccountActivationProps } from "../restaurant.config";

const BillingAndPayment = (props: AccountActivationProps) => {
  const { index, steps, setIndex, formData, setFormData } = props;
  const [toggle, setToggle] = useState({
    billing: false,
    payment: false,
  });

  const handleToggle = (tag: string) => {
    switch (tag) {
      case "billing":
        setToggle((prevState) => {
          return {
            ...prevState,
            billing: !toggle.billing,
          };
        });
        break;
      case "payment":
        setToggle((prevState) => {
          return {
            ...prevState,
            payment: !toggle.payment,
          };
        });
        break;

      default:
        break;
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    // const { tax_id, billing_info, account_details, business_Legal_name } =
    //   formData; // initially
    const { tax_id, business_Legal_name } = formData;
    if (
      tax_id === "" ||
      business_Legal_name === ""
      // billing_info.region === ""
      // account_details.account_name === "" ||
      // account_details.account_number === "" ||
      // account_details.bank === "" ||
      // billing_info.billing_address === "" ||
    ) {
      return;
    } else {
      setIndex((prevState) => prevState + 1);
    }
  };

  return (
    <div>
      <MDBContainer className="account-activation">
        <h1>Account Activation</h1>
        <Stages steps={steps} step={index} />
        <form onSubmit={handleSubmit} className="business-information">
          <div className="biz-cont">
            <h4>
              Business Information &nbsp;
              <CustomToolTip
                message="All fields marked with * are required"
                color="#FFAE0A"
                size={15}
              />
            </h4>
            <div>
              <label htmlFor="tin">
                Tax Identity No. (TIN)/National Identification Number (NIN)
                <span className="required-text">*</span>
              </label>
              <br />
              <MDBInput
                id="tin"
                tabIndex={1}
                value={formData.tax_id}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    tax_id: e.target.value.trim().toLowerCase(),
                  }))
                }
                type="text"
                required
              />
            </div>
            <div className="mt-2">
              <label htmlFor="b_name">
                Business Legal Name<span className="required-text">*</span>
              </label>
              <br />
              <MDBInput
                id="b_name"
                type="text"
                tabIndex={2}
                value={formData.business_Legal_name}
                onChange={(e) =>
                  setFormData((prevData) => ({
                    ...prevData,
                    business_Legal_name: e.target.value.trim().toLowerCase(),
                  }))
                }
                required
              />
            </div>
          </div>

          {/* billing section  */}
          {/* <div className="bill-cont"> 
            <div
              className="collapse-btn"
              onClick={() => handleToggle("billing")}
            >
              <h4>
                Billing Information &nbsp;
                <CustomToolTip
                  message="All fields marked with * are required"
                  color="#FFAE0A"
                  size={15}
                />
              </h4>
              {toggle.billing ? (
                <h4>
                  <TfiAngleUp />
                </h4>
              ) : (
                <h4>
                  <TfiAngleDown />
                </h4>
              )}
            </div>
            <MDBCollapse show={toggle.billing}>
              <div className="mt-2">
                <label htmlFor="b_address">
                  Billing Address<span className="required-text">*</span>
                </label>
                <br />
                <MDBInput
                  id="b_address"
                  type="text"
                  tabIndex={3}
                  value={formData.billing_info.billing_address}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      billing_info: {
                        ...formData.billing_info,
                        billing_address: e.target.value.toLowerCase(),
                      },
                    })
                  }
                  required
                />
              </div>
              <div className="mt-2">
                <label htmlFor="b_region">
                  State/Region<span className="required-text">*</span>
                </label>
                <br />
                <MDBInput
                  id="b_region"
                  type="text"
                  tabIndex={4}
                  value={formData.billing_info.region}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      billing_info: {
                        ...formData.billing_info,
                        region: e.target.value.toLowerCase(),
                      },
                    })
                  }
                  required
                />
              </div>
            </MDBCollapse>
          </div>
*/}
          {/* Payment section  */}
          {/* <div className="paym-cont">
            <div
              className="collapse-btn"
              onClick={() => handleToggle("payment")}
            >
              <h4>
                Payment Details &nbsp;
                <CustomToolTip
                  message="All fields marked * are required"
                  color="#FFAE0A"
                  size={15}
                />
              </h4>
              {toggle.payment ? (
                <h4>
                  <TfiAngleUp />
                </h4>
              ) : (
                <h4>
                  <TfiAngleDown />
                </h4>
              )}
            </div>
            <MDBCollapse show={toggle.payment}>

            </MDBCollapse>
          </div> */}

          <div className="form-btns">
            <MDBBtn className="back-btn" onClick={() => setIndex(index - 1)}>
              &larr; Back
            </MDBBtn>
            <MDBBtn className="proceed-btn" type="submit">
              Proceed &rarr;
            </MDBBtn>
          </div>
        </form>
      </MDBContainer>
    </div>
  );
};

export default BillingAndPayment;
